<div #modalContents [class]="lmodalContentsClassWithWidth" aria-modal="true" role="dialog" aria-labelledby="modalTitle">
  <asw-emergency-area #emergencyArea [isModal]="true"></asw-emergency-area>
  <div #modalHead *ngIf="header !== null" [class]="lmodalHeaderClass + ' u-modal-hedder-fix'">
    <ng-template #viewHead></ng-template>
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <asw-alert-area [isModal]="true"></asw-alert-area>
    <ng-template #view></ng-template>
    <asw-guidance-area [isModal]="true"></asw-guidance-area>
  </div>

  <div #modalFooter *ngIf="footer !== null" [class]="lmodalFooterClass">
    <ng-template #viewFoot></ng-template>
  </div>
</div>
